<template>
<div>
    ゴルフ場選択
    <select v-model="golf_coursecodes"> 
        <option v-for="golf_courses in this.golf_course" 
                v-bind:value="golf_courses.golf_code" 
                :key="golf_courses.id">
        {{ golf_courses.golf_name }}
        </option>
    </select>
    <router-link :to="{name:'reservepage',query:{gc:golf_coursecodes}}">ページ移行</router-link>
</div>
</template>

<script>
import { GET_GOLFCOURSE } from '../../constants/golf_course';

export default {
    components: {
    },
    data () {
        return {
            golf_coursecodes: null,
            golf_course: null,
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.GetGolfCourse();
        },
        GetGolfCourse: function () {
          this.$apollo.mutate({
                mutation: GET_GOLFCOURSE,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                }
              }).then(res => {
                 this.golf_course = res.data.getGolfCourse;
                 for (var i = 0; i < this.golf_course.length; i++ ) {
                     this.golf_course[i].id = i + 1;
                 }
              })
              .catch(error => {
                    this.error = error;
              });
        },
        accece(){
            this.$router.push("/reserve");
        },
    }
}

</script>

<style scoped>
</style>

